export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BRAND = {
  name: "HRKAPITAL",
  tagline: "Your path to financial freedom.",
  badge: "AMFI Registered Mutual Fund Distributor",
  phone: "+91 62027 43226",
  email: "services@hrkapital.co.in",
  address: "E-52, Bharat Vihar, Dwarka Sector 14, New Delhi",
  gstin: "07MJZPK9833K1ZV",
  arn: "ARN-369251",
};

export const TOPICS = [
  "Mutual Funds",
  "Financial Planning",
  "Investment Guidance",
  "Goal-Based Investing",
  "Wealth Management",
  "Protection Planning",
  "Something else",
];

export const ARTICLE_CATEGORIES = [
  "Financial Planning",
  "Mutual Funds",
  "Family & Goals",
  "Wealth",
  "Markets",
];

export const CATEGORY_TINTS = {
  "Financial Planning": "#DDF4FC",
  "Mutual Funds": "#DDF7EC",
  "Family & Goals": "#FBE5F1",
  Wealth: "#FFF7C7",
  Markets: "#E8EFF4",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) {
    if (window.location.pathname !== "/") {
      window.location.assign(`/#${id}`);
    }
    return;
  }
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
